// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import ReactDOM from 'react-dom'
import keycode from 'keycode'
import { withRouter, Link } from 'react-router-dom'
import uuidv4 from 'uuid/v4'
import { CopyToClipboard } from 'react-copy-to-clipboard'

// Internal Dependencies:
import SiteNotice from 'components/SiteNotice/SiteNotice'
import Share from 'components/Share/Share'
import { getUtcTimestampSeconds } from 'utilities/time'

// Redux:
import { likeProgram, hideProgramMenu, saveShareLink } from 'actions/site'
import { goToTrack, canPlayCheck } from 'actions/schedule'

class ProgramMenu extends React.Component {
	constructor( props ) {
		super( props )

		this.state = {
			isOpenLocal: true,
			clickedLike: false,
			clickedDislike: false,
			showLikeNotice: false,
			showFirstLikeNotice: false,
			showNotice: false,
			noticePromptLogin: false,
			noticeText: '',
			showShareUi: false,
			shareId: '',
			shareLink: ''
		}

		this.root = document.getElementById( 'program-menu' )
		this.el = document.createElement( 'div' )
	}

	componentDidMount() {
		this.root.appendChild( this.el )
		document.documentElement.classList.add( 'with-program-menu-open' )
		document.addEventListener( 'mousedown', this.handleClickOutside )
		document.addEventListener( 'keydown', this.handleKeyPress )
	}

	componentWillUnmount() {
		this.root.removeChild( this.el )
		document.documentElement.classList.remove( 'with-program-menu-open' )
		document.removeEventListener( 'mousedown', this.handleClickOutside )
		document.removeEventListener( 'keydown', this.handleKeyPress )
	}

	componentDidUpdate( prevProps ) {
		const { programMenu } = this.props
		const { isOpen, source } = programMenu
		const { isOpenLocal } = this.state

		if ( isOpen && ! prevProps.programMenu.isOpen ) {
			if ( 'share' == source ) {
				this.handleShareItemClick()
			}
		}

		if ( isOpen && ! prevProps.programMenu.isOpen && ! isOpenLocal ) {
			this.setState( {
				isOpenLocal: true
			} )
		}
	}

	handleClickOutside = ( e ) => {
		if ( this.outside == e.target ) {
			this.handleCancel()
		}
	}

	handleKeyPress = ( e ) => {
		if ( 'esc' == keycode( e ) ) {
			this.handleCancel()
		}
	}

	handleCancel = ( leaveNotice = false ) => {
		const { dispatch } = this.props

		this.setState( {
			isOpenLocal: false,
			clickedLike: false,
			clickedDislike: false,
			showLikeNotice: false,
			showFirstLikeNotice: false,
			showShareUi: false,
			shareLinkCopied: false
		} )

		if ( ! leaveNotice ) {
			this.setState( {
				showNotice: false,
				noticePromptLogin: false,
				noticeText: ''
			} )
		}

		setTimeout( () => {
			dispatch( hideProgramMenu() )
		}, 300 )
	}

	handleLikeClick = ( e ) => {
		const { dispatch, loggedIn, nowPlaying, accountData, programMenu } = this.props
		const { program, source } = programMenu
		const keepInState = 'favourites' == source

		this.handleCancel()

		if ( ! program ) {
			return
		}

		if ( ! loggedIn ) {
			this.setState( {
				showLikeNotice: true
			} )

			return
		}

		if ( accountData && ! accountData.likes || ! Object.keys( accountData.likes ).length ) {
			this.setState( {
				showFirstLikeNotice: true
			} )
		}

		dispatch( likeProgram( program, keepInState ) )

		this.setState( {
			clickedLike: true
		} )

		setTimeout( () => {
			this.setState( {
				clickedLike: false
			} )
		}, 700 )
	}

	handlePlayItemClick = ( e ) => {
		const { history, dispatch, programMenu, fullSchedule, isMobile } = this.props
		const { rewindMaxHours, futureFastForwardMaxHours, loggedIn } = this.props
		const id = e.currentTarget.getAttribute( 'data-id' )
		const item = fullSchedule[ id ]

		this.handleCancel()

		if ( programMenu.program.playCallback ) {
			programMenu.program.playCallback()

			return
		}

		if ( ! item ) {
			return
		}

		const canPlay = canPlayCheck( item, rewindMaxHours, futureFastForwardMaxHours, loggedIn, this.setNotice )

		if ( ! canPlay ) {
			return
		}

		dispatch( goToTrack( id ) )

		if ( isMobile ) {
			history.push( '/listen' )
		}
	}

	handleShareItemClick = ( e ) => {
		const { dispatch, programMenu, fullSchedule } = this.props
		const { rewindMaxHours, futureFastForwardMaxHours, loggedIn } = this.props
		const { program } = programMenu
		const id = program.key
		let item = fullSchedule[ id ]

		if ( ! item ) {
			item = program
		}

		if ( ! item ) {
			this.handleCancel()

			return
		}

		const canPlay = canPlayCheck( item, rewindMaxHours, futureFastForwardMaxHours, loggedIn, this.setNotice )

		if ( ! canPlay ) {
			this.handleCancel( true )

			return
		}

		const shareId = uuidv4()
		const shareLink = `${siteData.site_url}/share/${item.series_slug}/?share_id=${shareId}`

		this.setState( {
			showShareUi: true,
			shareId,
			shareLink
		} )

		dispatch( saveShareLink( shareId, item.series_slug, item.audio_file_url ) )
	}

	handleShareLinkCopied = () => {
		this.setState( {
			showShareUi: false,
			shareLinkCopied: true
		} )

		setTimeout( () => {
			this.handleCancel()

			setTimeout( () => {
				this.setState( {
					shareLinkCopied: false
				} )
			}, 300 )
		}, 1800 )
	}

	setNotice = ( text, promptLogin = false ) => {
		this.setState( {
			showNotice: true,
			noticeText: text,
			noticePromptLogin: promptLogin
		} )
	}

	handleCloseNotice = () => {
		this.setState( {
			showNotice: false,
			noticePromptLogin: false
		} )
	}

	renderMenu() {
		const { accountData, programMenu, fullSchedule, programsById, isMobile, isSingleProgram, page } = this.props
		const { isOpen, program, source } = programMenu
		const { isOpenLocal, showShareUi, shareLink, shareLinkCopied } = this.state

		if ( ! program ) {
			return null
		}

		const className = isOpenLocal ? 'site-notice is-open' : 'site-notice is-closed'
		const programUrl = program.audio_file_url
		const programKey = program.key

		let likeKey = program.audio_file_url
		let isLiked = false
		let likeButtonClass = '-like'

		if ( programUrl && accountData && accountData.likes && accountData.likes[ likeKey ] ) {
			isLiked = ! accountData.likes[ likeKey ].is_removed
			likeButtonClass += ' is-active'
		}

		let programExtraData

		if ( programsById[ `id_${program.series_slug}` ] ) {
			programExtraData = programsById[ `id_${program.series_slug}` ]
		}

		let programInfoNoticeLink = programExtraData ? `/programs/${ programExtraData.slug }` : false
		let heading = program.series
		let text = program.title

		if ( ( typeof program.guests == 'string' && program.guests.length > 0 ) ) {
			text += ` - ${program.guests}`
		}

		let showScrollToSchedule = false
		const scheduleUrl = program.is_program ? `/schedule-item/${program.key}` : '/schedule/'

		if ( 'now-playing' == source ) {
			showScrollToSchedule = true
		}

		let showInner = ! shareLinkCopied
		let showMainActions = ! showShareUi

		return (
			<div>
				<div className={ className } ref={ ( e ) => { this.outside = e } } tabIndex="0">
					{ shareLinkCopied &&
						<div className="-inner">
							<div className="-main">
								<header>
									<h4>Link copied to clipboard</h4>
								</header>
							</div>
						</div>
					}

					{ showInner &&
						<div className="-inner">
							<div className="-main">
								{ ( heading || text ) &&
									<header>
										{ heading &&
											<h4>{ heading }</h4>
										}

										{ text &&
											<p>{ text }</p>
										}
									</header>
								}

								{ showShareUi &&
									<div className="-actions -actions-with-icons">
										<CopyToClipboard text={ shareLink } onCopy={ this.handleShareLinkCopied }>
											<div>
												<span>Copy share link</span>

												<i className="icon-share" aria-hidden="true"></i>
											</div>
										</CopyToClipboard>

										<Share type="facebook" url={ shareLink } onClick={ this.handleCancel }>
											<span>Share via facebook</span>

											<i className="icon-facebook-official" aria-hidden="true"></i>
										</Share>

										<Share type="twitter" url={ shareLink } onClick={ this.handleCancel }>
											<span>Share via twitter</span>

											<i className="icon-twitter" aria-hidden="true"></i>
										</Share>

										<Share type="email" url={ shareLink } onClick={ this.handleCancel }>
											<span>Share via email</span>

											<i className="icon-envelope" aria-hidden="true"></i>
										</Share>

										{ isMobile &&
											<Share type="fb-messenger" url={ shareLink } onClick={ this.handleCancel }>
												<span>Share via messenger</span>

												<i className="icon-facebook-messenger" aria-hidden="true"></i>
											</Share>
										}

										{ isMobile &&
											<Share type="whatsapp" url={ shareLink } onClick={ this.handleCancel }>
												<span>Share via whatsapp</span>

												<i className="icon-whatsapp" aria-hidden="true"></i>
											</Share>
										}
									</div>
								}

								{ showMainActions &&
									<div className="-actions -actions-with-icons">
										<div onClick={ this.handlePlayItemClick } data-id={ programKey }>
											<span>Play</span>

											<i className="icon-playback-play" aria-hidden="true"></i>
										</div>

										{ program.isPodcaast &&
											<a href={ program.audio_file_url } onClick={ this.handleCancel }>
												<span>Download</span>

												<i className="icon-cloud-download-2" aria-hidden="true"></i>
											</a>
										}

										<div onClick={ this.handleShareItemClick }>
											<span>Share</span>

											<i className="icon-share" aria-hidden="true"></i>
										</div>

										{ ( programInfoNoticeLink && ( page.podcast_smart_filter || ! isSingleProgram ) ) &&
											<Link to={ programInfoNoticeLink } onClick={ this.handleCancel }>
												<span>Program Info</span>

												<i className="icon-info" aria-hidden="true"></i>
											</Link>
										}

										{ showScrollToSchedule &&
											<Link to={ scheduleUrl } onClick={ this.handleCancel }>
												<span>Show in Schedule</span>

												<i className="icon-calendar" aria-hidden="true"></i>
											</Link>
										}

										<div className={ likeButtonClass } onClick={ this.handleLikeClick } data-id={ programUrl }>
											{ isLiked &&
												<span>Remove from Favourites</span>
											||
												<span>Like</span>
											}

											{ isLiked &&
												<i className="icon-heart" aria-hidden="true" />
											||
												<i className="icon-heart-o" aria-hidden="true" />
											}
										</div>
									</div>
								}
							</div>

							<div className="-cancel">
								<div onClick={ this.handleCancel }>Cancel</div>
							</div>
						</div>
					}
				</div>
			</div>
		)
	}

	renderNotices() {
		const { showLikeNotice, showFirstLikeNotice, showNotice, noticeText, noticePromptLogin } = this.state

		return (
			<div>
				{ showLikeNotice &&
					<SiteNotice
						text="Please log in or create an account to use this feature"
						cancelText="Cancel"
						handleCancel={ this.handleCancel }
					>
						<div className="-actions">
							<Link to="/signin" onClick={ this.handleCancel }>Log in or Sign up</Link>
						</div>
					</SiteNotice>
				}

				{ showFirstLikeNotice &&
					<SiteNotice
						text="This program has been added to your favourites"
						cancelText="OK"
						handleCancel={ this.handleCancel }
					>
						<div className="-actions">
							<Link to="/favourites" onClick={ this.handleCancel }>View my favourites</Link>
						</div>
					</SiteNotice>
				}

				{ showNotice &&
					<SiteNotice
						text={ noticeText }
						cancelText="OK"
						handleCancel={ this.handleCancel }
					>
						{ noticePromptLogin &&
							<div className="-actions">
								<Link to="/signin" onClick={ this.handleCancel }>Log in or Sign up</Link>
							</div>
						}
					</SiteNotice>
				}
			</div>
		)
	}

	render() {
		const markup = (
			<div>
				{ this.renderMenu() }
				{ this.renderNotices() }
			</div>
		)

		return ReactDOM.createPortal(
			markup,
			this.el
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		accountData: state.site.accountData,
		loggedIn: state.site.loggedIn,
		isMobile: state.site.isMobile,
		programMenu: state.site.programMenu,
		fullSchedule: state.schedule.fullSchedule,
		programsById: state.programs.byId,
		rewindMaxHours: state.schedule.rewindMaxHours,
		futureFastForwardMaxHours: state.schedule.futureFastForwardMaxHours,
		loggedIn: state.site.loggedIn,
		page: state.page.selected
	}
}

export default withRouter(
	connect( mapStateToProps )( ProgramMenu )
)
